import { Entity } from '@sketchpixy/rubix/lib/L20n';
import _ from 'lodash';
import React from 'react';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import DoorClosedIconCustom from '../../components/CustomIcons/DoorClosedIconCustom.jsx';
import MksCylinderDetailsView from '../../components/MKS/MksCylinderDetailsView.jsx';
import MksCylindersHeader from '../../components/MKS/MksCylindersHeader.jsx';
import MksCylindersTableView from '../../components/MKS/MksCylindersTableView.jsx';
import OperationalView from '../../components/OperationalView/OperationalView.jsx';
import * as MksActions from '../../redux/actions/mks.actions';
import * as UtilsActions from '../../redux/actions/utils.actions';

let filterTimeout;

@connect(state => ({ 
  mks: state.mks, 
  routing: state.router, 
  language: state.settings.language, 
  viewLoading: state.utils.viewLoading, 
  themeName: state.settings.items.theme.data.themeName 
}))
class MksCylinders extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      isOperationalMode: false,
      typeFilter: '',
      doorNameFilter: '',
      filteredCylinders: [],
    };
  }

  async componentWillMount() {
    await this.onFetchCylinders();
  }

  componentWillUnmount() {
    const { dispatch } = this.props;
    dispatch(MksActions.setSelectedCylinder({}));
  }

  async onFetchCylinders(page = 0) {
    const { dispatch } = this.props;
    dispatch(UtilsActions.setViewLoading(true));
    try {
      await dispatch(MksActions.fetchCylinders(page));
    } catch (error) {
      console.error('Error fetching cylinders:', error);
    } finally {
      dispatch(UtilsActions.setViewLoading(false));
    }
  }

  onFetchCylindersOnPage(page) {
    this.onFetchCylinders(page);
  }

  async onSelectCylinder(cylinder) {
    const { dispatch } = this.props;
    try {
      dispatch(UtilsActions.setSpinnerVisibile(true));
      
      // Fetch associated keys for this cylinder
      const relationsData = await dispatch(MksActions.fetchCylinderRelations(cylinder.id));
      const keys = relationsData && relationsData.content ? _.map(relationsData.content, key => key.key) : [];
      
      // Set selected cylinder with relations data
      const cylinderWithRelations = {
        ...cylinder,
        associatedKeys: keys,
      };
      dispatch(MksActions.selectCylinder(cylinderWithRelations));
      this.setState({ isOperationalMode: true });
      dispatch(UtilsActions.setSpinnerVisibile(false));
    } catch (error) {
      console.error('Error fetching cylinder relations:', error);
      dispatch(MksActions.selectCylinder(cylinder));
      this.setState({ isOperationalMode: true });
      dispatch(UtilsActions.setSpinnerVisibile(false));
    }
  }

  onCloseOperationalSection() {
    const { dispatch } = this.props;
    this.setState({ isOperationalMode: false });
    dispatch(MksActions.setSelectedCylinder({}));
  }

  onRequestCylinderDuplication(cylinderData) {
    const { dispatch } = this.props;
    dispatch(push(`/mksRequests?cylinderId=${cylinderData.id}`));
  }

  onTypeChange(value) {
    clearTimeout(filterTimeout);
    filterTimeout = setTimeout(() => {
      this.setState({ typeFilter: value }, () => {
        this.onApplyFilters();
      });
    }, 300);
  }

  onDoorNameChange(value) {
    clearTimeout(filterTimeout);
    filterTimeout = setTimeout(() => {
      this.setState({ doorNameFilter: value }, () => {
        this.onApplyFilters();
      });
    }, 300);
  }

  onApplyFilters() {
    const { mks: { cylinders: { data: cylindersData } } } = this.props;
    const { typeFilter, doorNameFilter } = this.state;
    
    const allCylinders = cylindersData && cylindersData.content ? cylindersData.content : [];
    
    let filtered = allCylinders;
    
    if (typeFilter) {
      filtered = _.filter(filtered, cylinder => 
        cylinder.type && cylinder.type.toLowerCase().includes(typeFilter.toLowerCase())
      );
    }
    
    if (doorNameFilter) {
      filtered = _.filter(filtered, cylinder => 
        cylinder.doorName && cylinder.doorName.toLowerCase().includes(doorNameFilter.toLowerCase())
      );
    }
    
    this.setState({ filteredCylinders: filtered });
  }

  onSearchReset() {
    this.setState({ 
      typeFilter: '', 
      doorNameFilter: '',
      filteredCylinders: [] 
    });
  }

  getDisplayedCylinders() {
    const { mks: { cylinders: { data: cylindersData } } } = this.props;
    const { filteredCylinders, typeFilter, doorNameFilter } = this.state;
    
    const hasFilters = typeFilter || doorNameFilter;
    
    if (hasFilters) {
      return {
        content: filteredCylinders,
        pagination: {
          totalElements: filteredCylinders.length,
          number: 0,
          size: filteredCylinders.length,
          totalPages: 1,
        }
      };
    }
    
    return cylindersData;
  }

  render() {
    const { mks: { cylinders: { selectedCylinder } }, themeName, viewLoading } = this.props;
    const { isOperationalMode } = this.state;
    
    const displayedCylindersData = this.getDisplayedCylinders();
    const pagination = displayedCylindersData && displayedCylindersData ? _.omit(displayedCylindersData, 'content') : {};
    const numberOfCylinders = pagination.totalElements || 0;

    return (
      <div>
        <MksCylindersHeader
          themeName={themeName}
          onTypeChange={value => this.onTypeChange(value)}
          onDoorNameChange={value => this.onDoorNameChange(value)}
          onSearchReset={() => this.onSearchReset()}
          onRefresh={() => this.onFetchCylinders()}
          totalCylinders={numberOfCylinders}
          entitiesNumberSection={
            <div style={{ marginRight: 20, marginTop: 13, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
              <DoorClosedIconCustom style={{ width: 22 }} />
              <h4 style={{ marginTop: 5 }}>{numberOfCylinders}</h4>
            </div>
          }
        />
        <MksCylindersTableView
          cylindersData={displayedCylindersData}
          onSelectCylinder={cylinder => this.onSelectCylinder(cylinder)}
          onRefreshCylinders={() => this.onFetchCylinders()}
          onFetchCylindersOnPage={page => this.onFetchCylindersOnPage(page)}
        />
        <OperationalView
          themeName={themeName}
          isVisible={isOperationalMode}
          onClose={() => this.onCloseOperationalSection()}
          title={<Entity entity="cylinderDetails" />}
        >
          <div style={{ padding: 15 }}>
            <MksCylinderDetailsView
              cylinderData={selectedCylinder}
              onRequestCylinderDuplication={cylinderData => this.onRequestCylinderDuplication(cylinderData)}
            />
          </div>
        </OperationalView>
      </div>
    );
  }
} 

export default MksCylinders;

